import queryString from 'query-string';
import { isInsideLarkBrowser, isExternal } from './environment';

const getUrlParams = () => queryString.parse(location.search);

export const getAdaptConfigInFeishu = (type: string) => {
  if (isInsideLarkBrowser()) {
    /**
     * 飞书中适配逻辑：一级是页面，二级是模块
     * 适配需求：
     * 1.0 https://bytedance.feishu.cn/docx/G23FdQqZRoYejNxIc1RcreJvnZe
     * 2.0 https://bytedance.feishu.cn/docx/D5YIdfMWEos138xsctDcJr13nWe
     *
     * 隐藏飞书内水印：by 2023.10.19
     */
    const adaptConfigInFeishu = {
      common: {
        user: {
          showLanguage: false,
          showSwitchTenant: false,
          showLabBrowser: false,
          showMobile: false,
          showMoreInfo: false,
          showExistLogin: false,
          showThemeMenu: false,
        },
        get nav() {
          /* 飞书内默认收起导航 - 视图 */
          const reg = /\/(story|issue|workObject|multiProject)View\//;

          /** 页面刷新 - 不执行默认收起逻辑 */
          if (window.performance?.navigation?.type === 1) {
            return {};
          }

          if (reg.test(location.pathname)) {
            return {
              defaultFoldNav: true,
              defaultAutoFoldNav: true,
            };
          } else {
            return {};
          }
        },
        lang: {
          skipLockEN: true /** 去掉在 lark 中锁死英文的逻辑， 走 navigation.language 跟随 lark */,
          lockSystem: true,
        },
        theme: {
          lockSystem: true,
        },
      },
      openapp: {
        global: {
          hiddenUser: true, // 整体隐藏
        },
      },
      enterprise: {
        navFooter: {
          hiddenUser: true, // 整体隐藏
          showName: false,
        },
      },
      detail: {
        issueTran: {
          get visible() {
            const { open_status_tran } = getUrlParams(); // 本应该在这里判断是在详情页，但业务中存在 isDetail，直接用了。
            return !!+(open_status_tran || 0);
          },
        },
        screen: {
          get ignoreParentUrl() {
            /** 页面刷新，不执行详情页全屏逻辑 */
            if (window.performance?.navigation?.type === 1) {
              return false;
            }

            return true;
          } /* 飞书内详情页默认全屏打开，忽略 parentUrl 逻辑 */,
        },
        tabForm: {
          // 在飞书内详情表单 tab 中，开启避免单个控件宽度导致整体宽度超宽
          response: true,
        },
      },
      error: {
        tenantPage: {
          // 席位错误兜底页不展示切换入口
          hiddenSwitchEntry: true,
        },
      },
      platform: {
        waterWark: {
          hidden: true, // 隐藏飞书内水印
        },
      },
    };

    return adaptConfigInFeishu[type] || {};
  }

  return {};
};

/**
 * 飞书内：
 *  1. 协议用 https 即可
 *  2. target 为 _blank
 *  TODO: 接入新的打开群 applink，见 https://bytedance.feishu.cn/wiki/OcXCwPHA9iOljCkkfgnc1rnjnAf
 */
export const openJoinGroup = (chatId: string) => {
  let protocal = 'lark:',
    target = '_self';

  if (isInsideLarkBrowser()) {
    protocal = 'https:';
    target = '_blank';
  }

  const isOpenChatId = (chatId || '').startsWith('oc_');

  /** 背景：https://open.feishu.cn/document/server-docs/group/chat/chat-id-description-bytedance */
  const url =
    isExternal || isOpenChatId
      ? `${protocal}//applink.feishu.cn/client/chat/open?openChatId=${chatId}`
      : `lark://client/chat/${chatId}`;

  window.open(url, target);
};
